export default __webpack_public_path__ + "static/media/building_gold.faf5bd8c.png";